module.exports = __webpack_public_path__ + "static/media/flagGreen.4e0769bd.svg";